import { Employee } from '@/types'
import { ApiLink, ApiMeta } from '@/types/apis'

const MethodTypeAction = {
  POST: 0,
  PUT: 1,
  DELETE: 2,
  IMPORT: 3,
} as const

type MethodTypeAction = typeof MethodTypeAction[keyof typeof MethodTypeAction]

export { MethodTypeAction }

const TypeAction = {
  ATTENDANCE: 0,
  EMPLOYEE: 1,
  CSV_INSERT: 2,
  CSV_UPDATE: 3,
} as const

type TypeAction = typeof TypeAction[keyof typeof TypeAction]

export { TypeAction }

export type Action = {
  id: number
  methodType: MethodTypeAction
  createdAt: string
  newDataJa: string
  oldDataJa: string
  user: Employee
  type: TypeAction
}

export type GetActionResponse = {
  items: Action[]
  meta: ApiMeta
  links: ApiLink
}
